<template>
  <div class="meter-water-manage-container">
    <el-row :gutter="20">
      <el-col :span="4" class="tree-container">
        <room-tree-div ref="roomTree" @selectRoom="handleSelectRoom" />
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t("meterWater.queryConditions") }}</span>
          </div>
          <el-form
            :inline="true"
            :model="conditions"
            class="demo-form-inline text-left"
          >
            <el-form-item>
              <el-select
                v-model="conditions.meterType"
                :placeholder="$t('meterWater.selectMeterType')"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in meterTypes"
                  :key="item.typeId"
                  :label="item.typeName"
                  :value="item.typeId"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="conditions.waterId"
                :placeholder="$t('meterWater.inputMeterId')"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="conditions.paymentStatus"
                :placeholder="$t('meterWater.paymentStatus')"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="conditions.paymentType"
                :placeholder="$t('meterWater.paymentType')"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleQuery">{{
                $t("common.query")
              }}</el-button>
              <el-button @click="handleReset">{{
                $t("common.reset")
              }}</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="box-card margin-top">
          <div slot="header" class="flex justify-between">
            <span>{{ $t("meterWater.meterReadingInfo") }}</span>
            <div style="float: right">
              <el-button
                v-if="conditions.objId"
                type="primary"
                size="small"
                @click="handleOpenAddMeter"
              >
                {{ $t("meterWater.readMeter") }}
              </el-button>
              <el-button type="text" size="small" @click="handleOpenMeterType">
                {{ $t("meterWater.meterType") }}
              </el-button>
              <el-button
                v-if="conditions.objId"
                type="text"
                size="small"
                @click="handleOpenQrCode"
              >
                {{ $t("meterWater.qrCodeMeter") }}
              </el-button>
              <el-button
                type="text"
                size="small"
                style="margin-left: 10px"
                @click="handleOpenImport1"
              >
                <i class="el-icon-plus"></i>{{ $t("meterWater.import1") }}
              </el-button>
              <el-button
                type="text"
                size="small"
                style="margin-left: 10px"
                @click="handleOpenImport2"
              >
                <i class="el-icon-plus"></i>{{ $t("meterWater.import2") }}
              </el-button>
            </div>
          </div>

          <el-table :data="meterWaters" border style="width: 100%">
            <el-table-column
              prop="waterId"
              :label="$t('meterWater.meterId')"
              align="center"
            />
            <el-table-column
              prop="meterTypeName"
              :label="$t('meterWater.meterType')"
              align="center"
            />
            <el-table-column
              prop="objName"
              :label="$t('meterWater.objectName')"
              align="center"
            />
            <el-table-column
              prop="preDegrees"
              :label="$t('meterWater.preDegrees')"
              align="center"
            />
            <el-table-column
              prop="curDegrees"
              :label="$t('meterWater.curDegrees')"
              align="center"
            />
            <el-table-column prop="price" label="单价" align="center" />
            <el-table-column prop="totalAmount" label="总金额" align="center" />

            <!-- 统一加【是否】 -->
            <el-table-column label="是否开具发票" align="center" width="130">
              <template slot-scope="scope">
                <el-switch
                  :value="scope.row.invoiceFlag"
                  active-value="1"
                  inactive-value="0"
                  active-text="是"
                  inactive-text="否"
                  @click.native="handleInvoiceClick(scope.row)"
                />
              </template>
            </el-table-column>

            <el-table-column label="是否预开发票" align="center" width="130">
              <template slot-scope="scope">
                <el-switch
                  :value="scope.row.preInvoiceFlag"
                  active-value="1"
                  inactive-value="0"
                  active-text="是"
                  inactive-text="否"
                  @click.native="handlePreInvoiceClick(scope.row)"
                />
              </template>
            </el-table-column>

            <el-table-column label="是否上缴" align="center" width="110">
              <template slot-scope="scope">
                <el-switch
                  :value="scope.row.payFlag"
                  active-value="1"
                  inactive-value="0"
                  active-text="是"
                  inactive-text="否"
                  @click.native="handlePayFlagClick(scope.row)"
                />
              </template>
            </el-table-column>

            <el-table-column
              prop="companyName"
              label="企业名称"
              align="center"
            />
            <el-table-column prop="remarkSign" label="签名" align="center" />
            <el-table-column
              prop="feeStartDate"
              label="费用归属开始日期"
              align="center"
            />
            <el-table-column
              prop="feeEndDate"
              label="费用归属结束日期"
              align="center"
            />
            <el-table-column prop="multiple" label="倍率" align="center" />
            <el-table-column prop="difference" label="差额" align="center" />
            <el-table-column prop="useDegree" label="用量" align="center" />

            <el-table-column
              prop="preReadingTime"
              :label="$t('meterWater.preReadingTime')"
              align="center"
            />
            <el-table-column
              prop="curReadingTime"
              :label="$t('meterWater.curReadingTime')"
              align="center"
            />
            <el-table-column
              prop="paymentType"
              :label="$t('meterWater.paymentType')"
              align="center"
            />
            <el-table-column
              prop="paymentStatus"
              :label="$t('meterWater.paymentStatus')"
              align="center"
            />
            <el-table-column
              prop="createTime"
              :label="$t('meterWater.createTime')"
              align="center"
            />
            <el-table-column
              prop="remark"
              :label="$t('meterWater.remark')"
              align="center"
            />
            <el-table-column
              :label="$t('common.operation')"
              align="center"
              width="180"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleEdit(scope.row)"
                >
                  {{ $t("common.edit") }}
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="handleDelete(scope.row)"
                >
                  {{ $t("common.delete") }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            :current-page="pagination.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagination.size"
            :total="pagination.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </el-col>
    </el-row>

    <!-- 组件 -->
    <add-meter-water ref="addMeterWater" @success="handleSuccess" />
    <edit-meter-water ref="editMeterWater" @success="handleSuccess" />
    <delete-meter-water ref="deleteMeterWater" @success="handleSuccess" />
    <import-meter-water-fee ref="importMeterWaterFee" />
    <import-meter-water-fee2 ref="importMeterWaterFee2" />
    <room-meter-qrcode ref="roomMeterQrcode" />
  </div>
</template>

<script>
import {
  listMeterWaters,
  listMeterTypes,
  updateMeterWater,
} from "@/api/fee/meterWaterManageApi";
import { getCommunityId } from "@/api/community/communityApi";
import RoomTreeDiv from "@/components/room/roomTreeDiv";
import AddMeterWater from "@/components/fee/addMeterWater";
import EditMeterWater from "@/components/fee/editMeterWater";
import DeleteMeterWater from "@/components/fee/deleteMeterWater";
import ImportMeterWaterFee from "@/components/fee/importMeterWaterFee";
import ImportMeterWaterFee2 from "@/components/fee/importMeterWaterFee2";
import RoomMeterQrcode from "@/components/fee/roomMeterQrcode";

export default {
  name: "MeterWaterManageList",
  components: {
    RoomTreeDiv,
    AddMeterWater,
    EditMeterWater,
    DeleteMeterWater,
    ImportMeterWaterFee,
    ImportMeterWaterFee2,
    RoomMeterQrcode,
  },
  data() {
    return {
      conditions: {
        waterId: "",
        paymentStatus: "",
        paymentType: "",
        meterType: "",
        roomNum: "",
        objId: "",
        page: 1,
        row: 10,
        communityId: "",
      },
      meterWaters: [],
      meterTypes: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      roomName: "",
    };
  },
  created() {
    this.conditions.communityId = getCommunityId();
    this.loadData();
    this.loadMeterTypes();
  },
  methods: {
    async loadData() {
      try {
        const { data, total } = await listMeterWaters(this.conditions);
        this.meterWaters = data;
        this.pagination.total = total;
      } catch (error) {
        console.error("Failed to load meter waters:", error);
      }
    },
    async loadMeterTypes() {
      try {
        const { data } = await listMeterTypes({
          communityId: this.conditions.communityId,
          page: 1,
          row: 100,
        });
        this.meterTypes = data;
      } catch (error) {
        console.error("Failed to load meter types:", error);
      }
    },
    handleQuery() {
      this.conditions.page = 1;
      this.loadData();
    },
    handleReset() {
      this.conditions.waterId = "";
      this.conditions.paymentStatus = "";
      this.conditions.paymentType = "";
      this.conditions.meterType = "";
      this.conditions.roomNum = "";
      this.loadData();
    },
    handleSizeChange(val) {
      this.conditions.row = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.conditions.page = val;
      this.loadData();
    },
    handleSelectRoom({ roomId, roomName }) {
      this.conditions.objId = roomId;
      this.roomName = roomName;
      this.loadData();
    },
    handleOpenAddMeter() {
      this.$refs.addMeterWater.open({
        roomId: this.conditions.objId,
        roomName: this.roomName,
      });
    },
    handleEdit(row) {
      this.$refs.editMeterWater.open(row);
    },
    handleDelete(row) {
      this.$refs.deleteMeterWater.open(row);
    },
    handleOpenImport1() {
      this.$refs.importMeterWaterFee.open();
    },
    handleOpenImport2() {
      this.$refs.importMeterWaterFee2.open();
    },
    handleOpenQrCode() {
      this.$refs.roomMeterQrcode.open({
        roomId: this.conditions.objId,
        roomName: this.roomName,
      });
    },
    handleOpenMeterType() {
      this.$router.push("/views/fee/meterTypeManage");
    },
    handleSuccess() {
      this.loadData();
    },

    // ===================== 开关切换事件 =====================
    // 是否开具发票
    async handleInvoiceClick(row) {
      // 点击时还没修改任何数据，此时拿到原始旧值
      const oldVal = row.invoiceFlag;
      // 计算要切换到的新值
      const newVal = oldVal === "1" ? "0" : "1";

      this.$confirm("是否确认修改【是否开具发票】状态？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 用户点确定：才赋值新值，界面变化
          row.invoiceFlag = newVal;
          await updateMeterWater({
            waterId: row.waterId,
            invoiceFlag: row.invoiceFlag,
          });
          this.$message.success("修改成功！");
          this.loadData();
        })
        .catch(() => {
          // 用户取消，什么都不做，界面保持原样
        });
    },

    // 是否预开发票
    async handlePreInvoiceClick(row) {
      const oldVal = row.preInvoiceFlag;
      const newVal = oldVal === "1" ? "0" : "1";

      this.$confirm("是否确认修改【是否预开发票】状态？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          row.preInvoiceFlag = newVal;
          await updateMeterWater({
            waterId: row.waterId,
            preInvoiceFlag: row.preInvoiceFlag,
          });
          this.$message.success("修改成功！");
          this.loadData();
        })
        .catch(() => {});
    },

    // 是否上缴
    async handlePayFlagClick(row) {
      const oldVal = row.payFlag;
      const newVal = oldVal === "1" ? "0" : "1";

      this.$confirm("是否确认修改【是否上缴】状态？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          row.payFlag = newVal;
          await updateMeterWater({
            waterId: row.waterId,
            payFlag: row.payFlag,
          });
          this.$message.success("修改成功！");
          this.loadData();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.meter-water-manage-container {
  padding: 20px;

  .tree-container {
    min-height: 450px;
    overflow-y: auto;
    background: #fff;
    padding: 10px;
    border-radius: 4px;
  }

  .margin-top {
    margin-top: 20px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }
}
</style>
